// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"254":"8038711eb0e683b2b9fd","740":"792db0edf36ae921612e"}[chunkId] + ".css";
};